export default __webpack_public_path__ + "static/media/modal-search.3e927bd2.svg";